import { useCallback } from 'react'

import { LoggerKey } from '@config/logger'

import useLogger from '@hooks/useLogger'

interface ProductClickFieldsToValidate {
    category: string
    clickId: string
    customerId?: string
    productCode?: string
    scoreId?: string
}

const useLogMissingProductClickFields = () => {
    const { logInfo } = useLogger()

    const logMissingProductClickFields = useCallback(
        ({
            category,
            clickId,
            customerId,
            productCode,
            scoreId,
        }: ProductClickFieldsToValidate): void => {
            const missingFields: string[] = []

            if (!customerId) missingFields.push('customerId')
            if (!scoreId) missingFields.push('scoreId')
            if (!productCode) missingFields.push('productCode')
            if (!clickId) missingFields.push('clickId')

            if (missingFields.length > 0) {
                logInfo(LoggerKey.ProductClick, {
                    message: 'product_click event missing critical data',
                    missingFields,
                    category,
                    customerId,
                    scoreId,
                    productCode,
                    clickId,
                })
            }
        },
        [logInfo]
    )

    return { logMissingProductClickFields }
}

export default useLogMissingProductClickFields
